import { useFormik } from 'formik'

import { type StopAppointment } from 'core/appointments/domain/Appointment'

import { getOpenDockInitialValuesFromAppointment } from '../../domain/Appointment'
import { type OpenDockStopAppointment, type OpenDockWarehouseDetails } from '../../domain/Shipment'
import { type AppointmentCommonFormValues } from '../../infra/ShipmentRepository'
import { Reschedule } from './Reschedule'
import { getValidationSchema, Scheduled } from './Scheduled'

const STEPS = {
  SCHEDULED: 'scheduled',
  RESCHEDULE: 'reschedule',
}

export function StepContent({
  step,
  setStep,
  appointment,
  stopAppointment,
  warehouseDetails,
  facilityName,
  facilityTimezone,
  shipmentUUID,
  stopIndex,
  onCancelAppointment,
  onConfirm,
}: {
  step: string
  setStep: (step: string) => void
  appointment?: StopAppointment
  stopAppointment: OpenDockStopAppointment
  warehouseDetails: OpenDockWarehouseDetails
  facilityName?: string
  facilityTimezone?: string
  shipmentUUID: string
  stopIndex: number
  onCancelAppointment: () => void
  onConfirm?: () => void
}) {
  const initialValues = getOpenDockInitialValuesFromAppointment(appointment)
  const validationSchema = getValidationSchema()

  const { handleChange, values, isValid, isSubmitting, dirty } =
    useFormik<AppointmentCommonFormValues>({
      initialValues,
      validationSchema,
      onSubmit: () => undefined,
      enableReinitialize: true,
    })

  const rescheduleByCarrierForbidden = !warehouseDetails.allowCarrierRescheduleAppointment

  switch (step) {
    case STEPS.SCHEDULED:
      return (
        <Scheduled
          onReschedule={() => setStep(STEPS.RESCHEDULE)}
          onCancelAppointment={onCancelAppointment}
          stopAppointment={stopAppointment}
          facilityName={facilityName}
          facilityTimezone={facilityTimezone}
          rescheduleByCarrierForbidden={rescheduleByCarrierForbidden}
          values={values}
          handleChange={handleChange}
          isValid={isValid}
          dirty={dirty}
          isSubmitting={isSubmitting}
        />
      )
    case STEPS.RESCHEDULE:
      return (
        <Reschedule
          onBack={() => setStep(STEPS.SCHEDULED)}
          onRescheduleSuccess={() => {
            setStep(STEPS.SCHEDULED)
            onConfirm?.()
          }}
          misschedulingReasonValue={values.misschedulingReason?.value ?? ''}
          misschedulingNote={values.misschedulingNote}
          misschedulingFormValid={isValid && dirty}
          stopAppointment={stopAppointment}
          warehouseDetails={warehouseDetails}
          facilityName={facilityName}
          facilityTimezone={facilityTimezone}
          shipmentUUID={shipmentUUID}
          stopIndex={stopIndex}
        />
      )
    default:
      return null
  }
}
